const _prefix = '@notification/';

export default {
  SET_UP_NOTIFICATION: _prefix + 'SET_UP_NOTIFICATION',
  SHOW_NOTIFICATION: _prefix + 'SHOW_NOTIFICATION'
};
